{
  "user": {
    "email": {
      "label": "E-Mail-Adresse",
      "validations": {
        "required": "E-Mail-Adresse ist ein Pflichtfeld",
        "valid": "Ungültige E-Mail-Adresse"
      }
    },
    "password": {
      "label": "Passwort",
      "validations": {},
      "field": {
        "show": "Passwort anzeigen",
        "hide": "Passwort verbergen"
      }
    },
    "confirm_password": {
      "label": "Passwort bestätigen",
      "validations": {}
    },
    "firstName": {
      "label": "Vorname",
      "validations": {
        "required": "Geben Sie Ihren Vornamen ein"
      }
    },
    "middleName": {
      "label": "Weitere Vornamen",
      "validations": {}
    },
    "lastName": {
      "label": "Nachname",
      "validations": {
        "required": "Geben Sie Ihren Nachnamen ein"
      }
    },
    "phoneCountryCode": {
      "label": "Ländervorwahl",
      "place_holder": "Ländervorwahl",
      "validations": {}
    },
    "phoneNationalNumber": {
      "label": "Telefonnummer",
      "place_holder": "Telefonnummer",
      "validations": {}
    },
    "language": {
      "label": "Sprache",
      "place_holder": "Wählen Sie eine Sprache aus..",
      "validations": {}
    }
  },
  "organization": {
    "name": {
      "label": "Name",
      "validations": {
        "required": "Geben Sie den Namen der Organisation ein"
      }
    },
    "create": "Organisation erstellen",
    "select": "Organisation auswählen",
    "companyName": {
      "label": "Unternehmen",
      "validations": {
        "required": "Geben Sie den Unternehmensnamen der Organisation ein"
      }
    },
    "email": {
      "label": "E-Mail",
      "validations": {
        "required": "Geben Sie die Kontakt E-Mail ein",
        "valid": "Ungültige E-Mail"
      }
    },
    "vatNumber": {
      "label": "VAT",
      "validations": {
        "required": "Geben Sie die VAT Nummer ein",
        "valid": "Ungültige VAT Nummer"
      }
    },
    "language": {
      "label": "Sprache",
      "validations": {
        "required": "Wählen Sie die Sprache aus"
      }
    }
  },
  "department": {
    "label": "Abteilung",
    "overlay_title": "Neue Abteilung",
    "create": "Abteilung erstellen",
    "name": {
      "label": "Abteilungsname",
      "validations": {
        "empty": "Geben Sie den Namen der Abteilung ein",
        "duplicate_name": "Eine andere Abteilung mit diesem Namen existiert bereits",
        "min_length": "Der Name darf nicht kürzer als {{minLength}} Zeichen sein",
        "max_length": "Der Name darf nicht länger als {{maxLength}} Zeichen sein",
        "invalid": "Der Name muss mit einem Buchstaben beginnen und mit einem Buchstaben oder einer Ziffer enden. Er darf Leerzeichen, Punkte und Bindestriche enthalten."
      }
    },
    "organization": {
      "label": "Organisation",
      "validations": {
        "empty": "Wählen Sie eine Organisation aus"
      }
    },
    "description": {
      "label": "Beschreibung",
      "validations": {
        "empty": "Geben Sie eine Beschreibung an",
        "max_length": "Die Beschreibung darf nicht länger als 200 Zeichen sein"
      }
    },
    "thumbnail": {
      "label": "Thumbnail",
      "validations": {
        "empty": "Wählen Sie einen Thumbnail aus"
      }
    }
  },
  "project": {
    "label": "Projekt",
    "create": "Projekt erstellen",
    "not_allowed": "Sie haben keine Berechtigung, Projekte innerhalb dieser Organisation zu erstellen",
    "departmentId": {
      "label": "Abteilung",
      "place_holder": "",
      "validations": {
        "required": "Wählen Sie eine Abteilung aus"
      }
    },
    "name": {
      "label": "Name",
      "place_holder": "",
      "validations": {
        "required": "Geben Sie einen Projektnamen ein"
      }
    }
  },
  "cluster": {
    "label": "Cluster",
    "name": {
      "label": "Name"
    },
    "create": "Cluster erstellen",
    "create_service": "Service erstellen",
    "not_allowed": "Sie haben keine Berechtigung, Dienste innerhalb dieses Projekts zu erstellen",
    "replicas": {
      "label": "Replikate"
    },
    "description": {
      "label": "Beschreibung",
      "not_set": "Nicht gesetzt"
    },
    "allowed_source_ranges": {
      "label": "Erlaubte Netzwerke",
      "validations": {
        "invalid": "Ungültige IPv4 Adresse mit Subnetzmaske"
      },
      "network_mask_hint": "Dieses Feld erlaubt mehrere Eingaben. Bitte drücken Sie die Eingabe-Taste um einen Eintrag hinzuzufügen"
    },
    "k8s_status": {
      "label": "Status",
      "values": {
        "unavailable": "UNERREICHBAR",
        "running": "AKTIV",
        "creating": "INITIALISIERT",
        "updating": "AKTUALISIERT",
        "error": "FEHLER",
        "importing": "IMPORTIEREN",
        "starting": "BEGINNEND",
        "stopping": "STOPPEND",
        "stopped": "GESTOPPT"
      }
    },
    "patroni_status": {
      "label": "Patroni Status",
      "values": {
        "running": "Aktiv",
        "updating": "Aktualisiert",
        "pending": "Ausstehend"
      }
    },
    "connection_details": {
      "label": "Verbindungsdetails",
      "string": "Verbindungszeichenfolge",
      "read_only": {
        "label": "Lese-Zugriff"
      },
      "username": {
        "label": "Benutzername"
      },
      "password": {
        "label": "Passwort"
      }
    },
    "application_connection_details": {
      "label": "Anwendungs-Verbindungsdetails"
    }
  },
  "backups": {
    "logical": {
      "status": {
        "logical_backup_completed": "Logisches Backup abgeschlossen",
        "logical_backup_failed": "Logische Sicherung fehlgeschlagen"
      }
    }
  },
  "dataset": {
    "status": {
      "values": {
        "importing": "Import gestartet",
        "successful": "Import erfolgreich",
        "failure": "Import fehlgeschlagen",
        "aborted": "Import abgebrochen"
      },
      "secondary_text": "{{cluster}}"
    }
  },
  "address": {
    "line1": {
      "label": "Adresszeile 1",
      "place_holder": "",
      "validations": {
        "required": "Geben Sie die erste Adresszeile an"
      }
    },
    "line2": {
      "label": "Adresszeile 2",
      "place_holder": "",
      "validations": {}
    },
    "line3": {
      "label": "Adresszeile 3",
      "place_holder": "",
      "validations": {}
    },
    "postalCode": {
      "label": "Postleitzahl",
      "place_holder": "",
      "validations": {
        "required": "Geben Sie die Postleitzahl ein"
      }
    },
    "city": {
      "label": "Ort",
      "place_holder": "",
      "validations": {
        "required": "Geben Sie den Ort ein"
      }
    },
    "state": {
      "label": "Bundesland/Staat",
      "place_holder": "",
      "validations": {}
    },
    "countryCode": {
      "label": "Land",
      "place_holder": "Wählen Sie ein Land aus..",
      "validations": {
        "required": "Wählen Sie ein Land aus"
      }
    }
  },
  "compute_plan": {
    "label": "Leistungsplan",
    "cpu": {
      "label": "Kerne"
    },
    "memory": {
      "label": "RAM"
    }
  },
  "storage_plan": {
    "label": "Speicherplan",
    "type": {
      "label": "Art"
    },
    "size": {
      "label": "Größe"
    }
  },
  "languages": {
    "en": {
      "name": "Englisch"
    },
    "de": {
      "name": "Deutsch"
    },
    "es": {
      "name": "Spanisch"
    }
  },
  "countries": {
    "AT": {
      "name": "Österreich"
    },
    "CH": {
      "name": "Schweiz"
    },
    "DE": {
      "name": "Deutschland"
    }
  },
  "roles": {
    "owner": "Besitzer",
    "member": "Mitglied",
    "biller": "Buchhalter"
  }
}
